import { Tag } from 'antd';

const STATUS_COLOR = {
  active: 'green',
  approved: 'green',
  hired: 'green',
  submitted: 'gold',
  resubmitted: 'purple',
  pending: 'gold',
  draft: 'default',
  rejected: 'red',
  inactive: 'default',
  completed: 'blue',
  not_submitted: 'default',
};

export default function StatusBadge({ status }) {
  const label = String(status ?? 'unknown');
  const color = STATUS_COLOR[label.toLowerCase()] ?? 'default';

  return (
    <Tag color={color} style={{ borderRadius: 6, fontWeight: 600, fontSize: 12, textTransform: 'capitalize' }}>
      {label.replace(/_/g, ' ')}
    </Tag>
  );
}
